export default __webpack_public_path__ + "static/media/Castro.f719176a.png";